import { createI18n } from 'vue-i18n';

import baseLocales from '@/shared/assets/locale.json';

export default createI18n({
  legacy: false,
  locale: 'en',
  missingWarn: false,
  messages: baseLocales,
});
